import { ApolloClient } from "@apollo/client";
import { createAppSyncHybridLink } from "./appSyncHybridLink";

export const createAppSyncApolloClient = async ({
  appSyncApiUrl,
  getJwtToken,
  cacheConfig,
}) =>
  new ApolloClient({
    link: await createAppSyncHybridLink({ appSyncApiUrl, getJwtToken }),
    cache: cacheConfig,
    // connectToDevTools
  });
